import {
  Box,
  Container,
  Grid,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
  Button,
  Table,
  Select,
  TableRow,
  TableCell,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { backend } from "../../api";
import { updateCart } from "../../redux-store/shop/shop";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { checkoutFormSchema } from "../Checkout/checkoutForm";
import { Link, useHistory, useParams } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import {
  createBookOrder,
  fetchBookDetails,
  fetchPreOrderBooks,
} from "../../redux-store/books/actions";
import { RESET_BOOK, RESET_BOOK_ORDER } from "../../redux-store/constants";
import { getTax } from "../../utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "40px 0",
  },
  sectionHeading: {
    fontSize: "36px",
    fontWeight: 600,
  },
  formLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
  },
  placeSelector: {
    padding: "8px",
    width: "100%",
    borderRadius: "2px",
  },
  inputField: {
    padding: "10px",
    borderRadius: "5px",
    width: "100%",
  },
  shopBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "30px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  radioBtns: {
    margin: "0",
    // backgroundColor:'red',
    // border: '2px solid yellow'
  },
  radioLabels: {
    fontSize: "14px",
  },
}));

const PreOrder = () => {
  const classes = useStyles();
  const formRef = useRef();
  const { currentUser } = useSelector((state) => state.auth);
  const { preOrderBooks, loading, error } = useSelector(
    (state) => state.preorders
  );
  console.log(currentUser);
  const { currentItem } = useSelector((state) => state.book);
  const { order, success } = useSelector((state) => state.bookOrder);
  const [billingAddress, setBillingAddress] = useState(
    currentUser?.addresses ? currentUser?.addresses[0] : "ABC"
  );

  const history = useHistory();
  const dispatch = useDispatch();
  const [amounts, setAmounts] = useState();
  const [bookPrice, setBookPrice] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [deliveryType, setDeliveryType] = useState();
  const [taxAmount, setTaxAmount] = useState(0);
  const [bookId, setBookId] = useState();
  const [bookType, setBookType] = useState();

  useEffect(() => {
    dispatch({ type: RESET_BOOK });
    if (currentUser?.user) {
      handleFetchCurrentAmount();
      dispatch(fetchPreOrderBooks());
    }
  }, [currentUser]);

  useEffect(() => {
    if (success === true) {
      dispatch({ type: RESET_BOOK_ORDER });
      history.push(`/dashboard/customer`);
    }
  }, [success]);

  const handleRequestOrder = () => {
    let delivery;
    let price;
    let total = +bookPrice + +taxAmount + +deliveryPrice;

    if (deliveryType === "standard") {
      delivery = {
        standard_delivery: deliveryPrice,
      };
    } else if (deliveryType === "three_days") {
      delivery = {
        three_days_delivery: deliveryPrice,
      };
    } else if (deliveryType === "next_day") {
      delivery = {
        next_day_delivery: deliveryPrice,
      };
    }
    if (bookType === "paper_back") {
      price = {
        paperback_price: bookPrice,
      };
    } else if (bookType === "hard_cover") {
      price = {
        hardcover_price: bookPrice,
      };
    } else {
      price = {
        digital_price: bookPrice,
      };
    }
    const newOrder = {
      total_price: +total,
      book_price: price,
      status: "pre order",
      source_of_approaching: "family",
      user: currentUser.user._id,
      book: bookId,
      shipping_address: {
        country: billingAddress.country,
        state: billingAddress.state,
        city: billingAddress.city,
        zip: billingAddress.zip,
        name: billingAddress.name,
      },
      billing_details: {
        payment_type: "paypal",
        delivery_type: currentItem.print_on_demand,
        delivery_amount: deliveryPrice,
        delivery: delivery,
        tax_amount: {
          percentage: amounts.tax,
          amount: taxAmount,
        },
      },
    };
    dispatch(createBookOrder(newOrder));
  };
  const handleFetchCurrentBook = (val) => {
    if (val) dispatch(fetchBookDetails(val));
    else {
      setBookId(null);
    }
  };

  const handleFetchCurrentAmount = () => {
    backend
      .get("/amount")
      .then((res) => {
        setAmounts(res.data.data[0]);
      })
      .catch((err) => {});
  };

  const handleChangeValues = (value) => {
    if (value === "digital_ebook") {
      setBookType(value);
      setBookPrice(currentItem?.price?.digital_price);
      setDeliveryPrice(1);
      setDeliveryType("just download");
      let tax = getTax(amounts, currentItem, "digital_price");
      setTaxAmount(tax);
    } else if (value === "hard_cover") {
      setBookPrice(currentItem?.price?.hardcover_price);
      setBookType(value);
      setDeliveryPrice(0);
      setDeliveryType(null);
      let tax = getTax(amounts, currentItem, "hardcover_price");
      setTaxAmount(tax);
    } else if (value === "paper_back") {
      setBookPrice(currentItem?.price?.paperback_price);
      setBookType(value);
      setDeliveryPrice(0);
      setDeliveryType(null);
      let tax = getTax(amounts, currentItem, "paperback_price");
      setTaxAmount(tax);
    }
  };
  const handleDeliveryType = (val) => {
    if (val === "next_day") {
      setDeliveryPrice(currentItem?.delivery.next_day_delivery);
    } else if (val === "three_days") {
      setDeliveryPrice(currentItem?.delivery.three_days_delivery);
    } else {
      setDeliveryPrice(currentItem?.delivery.standard_delivery);
    }
    setDeliveryType(val);
  };

  return (
    <Fragment>
      <Helmet>
        <title>Pre Orders - d2p</title>
      </Helmet>
      <PageBanner title="Pre Orders" image="/assets/images/bg4.jpg" />
      <ToastContainer />
      {currentUser?.user && currentUser.user.role === "customer" ? (
        <Container>
          <div className={classes.root}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <h2 className={classes.sectionHeading}>
                      BOOKS AVAILABLE FOR PRE ORDER
                    </h2>
                    <Box mb={2}>
                      <InputLabel className={classes.formLabel}>
                        Pre Order Books:
                      </InputLabel>
                      <FormControl variant="outlined" fullWidth>
                        <Select
                          native
                          onChange={(e) => {
                            setBookId(e.target.value);
                            handleFetchCurrentBook(e.target.value);
                          }}
                        >
                          <option required value="">
                            Select Book
                          </option>
                          {preOrderBooks?.map((item) => (
                            <option value={item._id}>{item.book_title}</option>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <h2 className={classes.sectionHeading}>Billing Address</h2>
                    {currentUser.user && billingAddress && (
                      <form>
                        <Box mb={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <InputLabel className={classes.formLabel}>
                                Country
                              </InputLabel>
                              <CountryDropdown
                                valueType="short"
                                name="country"
                                className={classes.inputField}
                                value={billingAddress.country}
                                onChange={(_, e) => {
                                  setBillingAddress({
                                    ...billingAddress,
                                    country: e.target.value,
                                  });
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <InputLabel className={classes.formLabel}>
                                State
                              </InputLabel>
                              <RegionDropdown
                                className={classes.inputField}
                                name="state"
                                countryValueType="short"
                                country={billingAddress.country}
                                value={billingAddress.state}
                                onChange={(_, e) => {
                                  setBillingAddress({
                                    ...billingAddress,
                                    state: e.target.value,
                                  });
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                        <Box mb={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <InputLabel className={classes.formLabel}>
                                City / Town
                              </InputLabel>
                              <OutlinedInput
                                type="text"
                                className={classes.inputField}
                                value={billingAddress.city}
                                name="city"
                                onChange={(e) => {
                                  setBillingAddress({
                                    ...billingAddress,
                                    city: e.target.value,
                                  });
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <InputLabel className={classes.formLabel}>
                                ZIP
                              </InputLabel>
                              <OutlinedInput
                                type="text"
                                className={classes.inputField}
                                value={billingAddress.zip}
                                name="zip"
                                onChange={(e) => {
                                  setBillingAddress({
                                    ...billingAddress,
                                    zip: e.target.value,
                                  });
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                        <Box mb={2}>
                          <InputLabel className={classes.formLabel}>
                            Street Address
                          </InputLabel>
                          <OutlinedInput
                            type="text"
                            className={classes.inputField}
                            value={billingAddress.name}
                            name="street"
                            onChange={(e) => {
                              setBillingAddress({
                                ...billingAddress,
                                name: e.target.value,
                              });
                            }}
                          />
                        </Box>
                      </form>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <h2 className={classes.sectionHeading}>Your Order</h2>
                {currentItem && bookId ? (
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      lg={3}
                      style={{ textAlign: "center" }}
                    >
                      <img
                        src={currentItem.book_cover}
                        style={{ maxWidth: "80%" }}
                        alt=""
                      />
                      <h3>{currentItem.book_title}</h3>
                    </Grid>
                    <Grid item xs={12} md={8} lg={9}>
                      <Table>
                        <TableRow>
                          <TableCell>
                            <h4>Book Type</h4>
                            <FormControl>
                              <RadioGroup
                                value={bookType}
                                name="book type"
                                onChange={(e) =>
                                  handleChangeValues(e.target.value)
                                }
                              >
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  value="hard_cover"
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      Limited Edition Hard Back
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  value="paper_back"
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      Paper Back
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  value="digital_ebook"
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      Digital eBook
                                    </span>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>$ {bookPrice}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <h4>Delivery Options</h4>
                            <FormControl
                              disabled={bookType === "digital_ebook"}
                            >
                              <RadioGroup
                                value={deliveryType}
                                name="Delivery"
                                onChange={(e) =>
                                  handleDeliveryType(e.target.value)
                                }
                              >
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  checked={deliveryType == "next_day"}
                                  value={"next_day"}
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      Next day
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  value={"three_days"}
                                  checked={deliveryType == "three_days"}
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      3 days
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.radioBtns}
                                  value={"standard"}
                                  checked={deliveryType == "standard"}
                                  control={<Radio size="small" />}
                                  label={
                                    <span className={classes.radioLabels}>
                                      Standard
                                    </span>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>$ {deliveryPrice}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <h4>Tax ({amounts?.tax} %)</h4>
                          </TableCell>
                          <TableCell>$ {taxAmount}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <h4>Total</h4>
                          </TableCell>
                          <TableCell>
                            <h4>$ {deliveryPrice + bookPrice + taxAmount}</h4>
                          </TableCell>
                        </TableRow>
                      </Table>
                    </Grid>
                  </Grid>
                ) : (
                  <Box align="center">
                    <Skeleton animaion="wave" />
                  </Box>
                )}
              </Grid>
            </Grid>
            <div>
              <Box display="flex" alignItems="center" flexWrap="wrap">
                <h4>PayPal</h4>
                <img
                  src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg"
                  alt=""
                  style={{ margin: "0 10px" }}
                />
                <h4>What is PayPal?</h4>
              </Box>
              <p>
                Pay via PayPal; you can pay with your credit card if you don’t
                have a PayPal account.
              </p>
              <p>
                Your personal data will be used to process your order, support
                your experience throughout this website, and for other purposes
                described in our privacy policy.
              </p>
              <Button
                className={classes.shopBtn}
                disabled={!bookType || !deliveryType}
                onClick={handleRequestOrder}
              >
                Proceed to PayPal
              </Button>
            </div>
          </div>
        </Container>
      ) : (
        <Container>
          <Box my={5} textAlign="center">
            <Typography
              variant="body1"
              color="error"
              style={{ fontWeight: 600, fontSize: 36, lineHeight: 1 }}
            >
              You need to Login as customer before pre ordering book
            </Typography>
          </Box>
        </Container>
      )}
    </Fragment>
  );
};

export default PreOrder;
